var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.progressBarRecipe(_setup.props).root(),attrs:{"data-component":"CsProgressBar","data-slot":"root"}},[_c('div',{class:_setup.progressBarRecipe(_setup.props).progress(),style:({
      width: `${_vm.progress}%`,
    }),attrs:{"data-slot":"progress"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }